import React from 'react';
import { compose } from 'react-apollo';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { withRouter, RouterProps } from 'react-router';
import { createUserProductDiscountVariables, updateUserProductDiscountVariables, createUserShippingDiscountVariables, updateUserShippingDiscountVariables } from '@api/graphql/types';
import { DiscountType } from '../types';
import Paths from '@root/utils/Path';
import Form from '@components/Form/Form';

interface Props {
    discountType: DiscountType;
    formData: createUserProductDiscountVariables | updateUserProductDiscountVariables;
    onSubmit: (formData: FormDataType) => Promise<any>;
}

type PropType = Props & InjectedIntlProps & RouterProps;
type FormDataType = createUserProductDiscountVariables | createUserShippingDiscountVariables | updateUserProductDiscountVariables | updateUserShippingDiscountVariables;

class UserDiscountForm extends React.Component<PropType> {
    private validate = () => {
        return true;
    }

    private onSubmit = (formData: FormDataType) => {
        return this.props.onSubmit(formData);
    }

    public render() {

        const fields = [
            { name: 'is_active', type: 'checkbox' },
            { name: 'discount', type: 'number', props: {step: '0.01', required: true} },
            { name: 'active_from', type: 'datetime', props: {required: true} },
            { name: 'active_to', type: 'datetime', props: {required: true} },
        ];

        return (
            <Form
                intlPrefix='module.user.product-discounts'
                fields={[{id: 'default', fields}]}
                formData={this.props.formData}
                onSubmit={this.onSubmit}
                validate={this.validate}
                redirectPath={Paths.user}
            />
        );
    }
}

export default compose(
    injectIntl,
    withRouter,
)(UserDiscountForm);



// WEBPACK FOOTER //
// ./src/modules/User/components/UserDiscountForm.tsx